/**
 * Current-time line. Only rendered when the displayed date is today.
 * Position updates every 30s through a ref (no React renders).
 */
import React, { useEffect, useRef } from "react";
import { MCGridConfig } from "../model/types";
import { dateToMinutes, yForMin } from "../model/gridGeometry";

const NowLine: React.FC<{ cfg: MCGridConfig; date: Date }> = ({ cfg, date }) => {
  const ref = useRef<HTMLDivElement>(null);
  const isToday = new Date().toDateString() === date.toDateString();

  useEffect(() => {
    if (!isToday) return;
    const el = ref.current;
    if (!el) return;

    const update = () => {
      const min = dateToMinutes(new Date());
      if (min < cfg.dayStartMin || min > cfg.dayEndMin) {
        el.style.opacity = "0";
        return;
      }
      el.style.opacity = "1";
      el.style.transform = `translateY(${yForMin(cfg, min)}px)`;
    };

    update();
    const id = setInterval(update, 30_000);
    return () => clearInterval(id);
  }, [cfg, isToday]);

  if (!isToday) return null;
  return <div ref={ref} className="mc-now-line" style={{ opacity: 0 }} />;
};

export default React.memo(NowLine);
